import { render, staticRenderFns } from "./TariffRegionFormDialog.vue?vue&type=template&id=04e47d84&"
import script from "./TariffRegionFormDialog.vue?vue&type=script&lang=ts&"
export * from "./TariffRegionFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports